/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MaslInputs */

const en_masl = /** @type {(inputs: MaslInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASL`)
};

const es_masl = /** @type {(inputs: MaslInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASL`)
};

/**
* | output |
* | --- |
* | "MASL" |
*
* @param {MaslInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const masl = /** @type {((inputs?: MaslInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MaslInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_masl(inputs)
	return es_masl(inputs)
});